export const QUERY_KEYS = {
  compoundMap: 'compoundMap',
  compoundOccupancy: 'compoundOccupancy',
  productImagery: 'productImagery',
  dashboardKpiSummary: 'dashboardKpiSummary',
  dashboardThroughputTrend: 'dashboardThroughputTrend',
  dashboardStockByCompound: 'dashboardStockByCompound',
  dashboardStockByModel: 'dashboardStockByModel',
  dashboardStockByStatus: 'dashboardStockByStatus',
  dashboardLoadPulling: 'dashboardLoadPulling',
  dashboardEventHeatmap: 'dashboardEventHeatmap',
  dashboardLoadPullingSummary: 'dashboardLoadPullingSummary',
  dashboardMaintenance: 'dashboardMaintenance',
  company: 'company',
  companyTypes: 'companyTypes',
  countries: 'countries',
  documentManagementDocumentType: 'documentManagementDocumentType',
  documentManagementDocument: 'documentManagementDocument',
  appFeatures: 'appFeatures',
  appDataRules: 'appDataRules',
  gbaUsers: 'gbaUser',
  inspectionsReportsInitial: 'inspectionsReportsInitial',
  inspectionsVehiclesFilters: 'inspectionsVehiclesFilters',
  inspectionsVehiclesList: 'inspectionsVehiclesList',
  inspectionsVehiclesInsights: 'inspectionsVehiclesInsights',
  inspectionsVehicle: 'inspectionsVehicle',
  inspectionsVehicleStatus: 'inspectionsVehicleStatus',
  inspectionsVehiclesParts: 'inspectionsVehiclesParts',
  inspectionsVehiclesPartsByFrCode: 'inspectionsVehiclesPartsByFrCode',
  inspectionsVehiclesInspectors: 'inspectionsVehiclesInspectors',
  inspectionsVehiclesNotes: 'inspectionsVehiclesNotes',
  inspectionsMechanicalsNotes: 'inspectionsMechanicalsNotes',
  inspectionsMechanicalsWheels: 'inspectionsMechanicalsWheels',
  inspectionsVehiclesMechanicalsNotes: 'inspectionsVehiclesNotes',
  inspectionsVehiclesSummaries: 'inspectionsVehiclesSummaries',
  inspectionsChecklistDynamicOperations:
    'inspectionsChecklistDynamicOperations',
  inspectionsChecklistElectricHybrid: 'inspectionsChecklistElectricHybrid',
  inspectionsChecklistEngineRunning: 'inspectionsChecklistEngineRunning',
  inspectionsChecklistInterior: 'inspectionsChecklistInterior',
  inspectionDamageImage: 'inspectionDamageImage',
  inspectionStatusAccessRules: 'inspectionStatusAccessRules',
  inspectionStatuses: 'inspectionStatuses',
  emailNotificationRoleAccess: 'emailNotificationRoleAccess',
  novuWorkflowOptions: 'novuWorkflowOptions',
  myEmailNotificationPreferences: 'myEmailNotificationPreferences',
  releaseNotes: 'releaseNotes',
  latestReleaseNote: 'latestReleaseNote',
  releaseNoteHistory: 'releaseNoteHistory',
  stockReconciliation: 'stockReconciliation',
  stockReconciliationHistory: 'stockReconciliationHistory',
  stockReconciliationQueue: 'stockReconciliationQueue',
  stockReconciliationRows: 'stockReconciliationRows',

  location: 'location',
  locationTypes: 'locationTypes',
  locationAW: 'locationAW',
  orderSummary: 'orderSummary',
  damages: 'damages',
  preTimeSuggestions: 'preTimeSuggestions',
  damageItem: 'damageItem',
  damageCodes: 'damageCodes',
  damageConditionCodes: 'damageConditionCodes',
  damageSeverityCodes: 'damageSeverityCodes',
  damageRepairActionCodes: 'damageRepairActionCodes',
  conditions: 'conditions',
  damageClassificationChangeSummary: 'damageClassificationChangeSummary',
  workCenters: 'workCenters',
  labour: 'labour',
  supplier: 'supplier',
  damageParts: 'damageParts',
  damagePartsById: 'damagePartsById',
  passports: 'passports',
  passportsJobs: 'passportsJobs',
  passportsTransactions: 'passportsTransactions',
  passportsArrivals: 'passportsArrivals',
  pts: 'pts',
  pipeline: 'pipeline',
  pipelineGraph: 'pipelineGraph',
  pipelineLocations: 'pipelineLocations',
  role: 'role',
  userType: 'userType',
  serviceProviders: 'serviceProviders',
  serviceUnits: 'serviceUnits',
  serviceUnitTypes: 'serviceUnitTypes',
  storage: 'storage',
  storageGraph: 'storageGraph',
  storageVehiclesFilters: 'storageVehiclesFilters',
  storageVehiclesList: 'storageVehiclesList',
  customers: 'customer',
  customersHierarchy: 'customersHierarchy',
  customerInspectors: 'customerInspectors',
  shippingPlan: 'shippingPlan',
  transportMovements: 'transportMovements',
  transportMovementsSearch: 'transportMovementsSearch',
  transportLoadDetails: 'transportLoadDetails',
  transportLoadLogs: 'transportLoadLogs',
  transportPositions: 'transportPositions',
  tnrdetails: 'tnrdetails',
  users: 'user',
  userPermissions: 'permissions',
  tmsUsers: 'tmsUsers',
  vesselMovements: 'vesselMovements',
  vesselPositions: 'vesselPositions',
  vessels: 'vessels',
  vesselPorts: 'vesselPorts',
  vesselAgents: 'vesselAgents',
  vesselBerths: 'vesselBerths',
  vesselPortCalls: 'vesselPortCalls',
  vesselJourneys: 'vesselJourneys',
  shippingManifests: 'shippingManifests',
  logs: 'logs',
  mechanicalInspection: 'mechanicalInspection',
  mechanicalInspectionAvailable: 'mechanicalInspectionAvailable',
  fprInspection: 'fprInspection',
  mot: 'mot',
  jobChains: 'jobChains',
  jobChainsList: 'jobChainsList',
  jobsList: 'jobsList',
  jobChainDag: 'jobChainDag',
  jobChainFilters: 'jobChainFilters',
  jobTypes: 'jobTypes',
  jobStatus: 'jobStatus',
  jobTags: 'jobTags',
  jobTemplates: 'jobTemplates',
  jobChainTemplateList: 'jobChainTemplateList',
  jobChainTemplateMetadata: 'jobChainTemplateMetadata',
  jobChainTemplateDetail: 'jobChainTemplateDetail',

  damageExceptions: 'damageExceptions',
  damageExceptionsList: 'damageExceptionsList',

  loadLanes: 'loadLanes',

  commandCentreSites: 'commandCentreSites',
  commandCentreConfig: 'commandCentreConfig',
  commandCentreOperators: 'commandCentreOperators',
  commandCentreEvents: 'commandCentreEvents',
  commandCentreCameras: 'commandCentreCameras',
  commandCentreCameraStream: 'commandCentreCameraStream',
  commandCentreOperator: 'commandCentreOperator',
  commandCentrePositions: 'commandCentrePositions',
  commandCentreAssignableJobs: 'commandCentreAssignableJobs',

  questionnaireTemplateList: 'questionnaireTemplateList',
  questionnaireTemplateEdit: 'questionnaireTemplateEdit',
  questionnaireTemplate: 'questionnaireTemplate',
  questionnaireResponse: 'questionnaireResponse',
  questionnaireResponseList: 'questionnaireResponseList',
};
